import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LOANDEPOT_NMLS_ID, LOANDEPOT_URLS } from '@ld.consumer-portal/constants';
import { equalHousingLender } from '@ld.consumer-portal/data-uri';
import { PlatformService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-under-maintenance-page',
  imports: [TranslocoDirective],
  templateUrl: './under-maintenance-page.component.html',
  styleUrl: './under-maintenance-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnderMaintenancePageComponent {
  private readonly platformService = inject(PlatformService);

  readonly message = input<string>('');

  protected readonly isNativeMobile = this.platformService.isNativeMobile;
  protected readonly logo = '/assets/images/loandepot-logo-3d-dark-metallic.svg';
  protected readonly maintenanceImage = '/assets/images/under-maintenance-v1.png';
  protected readonly equalHousingLogo = equalHousingLender;
  protected readonly nmlsId = LOANDEPOT_NMLS_ID;
  protected readonly nmlsConsumerAccessUrl = LOANDEPOT_URLS.NMLS_CONSUMER_ACCESS;
  protected readonly privacyUrl = LOANDEPOT_URLS.PRIVACY_AND_SECURITY;
  protected readonly termsOfUseUrl = LOANDEPOT_URLS.TERMS_OF_USE;
  protected readonly currentYear = new Date().getFullYear();
}
